import React from "react";
import { Link } from "react-router-dom";
import { Api } from "../app-controller.js";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ShowForm from "../components/electronic-prescription/ShowForm";
import classnames from "classnames";
import Swal from "sweetalert2";
import printJS from "print-js";

class Visits extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      previa: false,
      previa_url: "",
      modalState: false,
      working: true,
      workingModal: true,
      observationModalOpen: false,
      observacion: "",
      toggle: false,
      paginaActual: 0,
      paginaActual_vi: 0,
      paginas: 0,
      especie: "",
      paginas_vi: 0,
      registros: 0,
      registros_vi: 0,
      cat_especies: Api.loadCatalogue("cat_especie"),
      surtidas: [],
      receta_electronica: "",
      activeTab: "1",
      nivelUsuario: localStorage.nivel_actual,
      buscar: {},
      collapse: [
        {
          id: 1,
          collapse: true,
        },
        {
          id: 2,
          collapse: false,
        },
      ],
    };
  }

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  toggleCollapse = (index) => {
    var newArray = [];
    for (let collapseObj of this.state.collapse) {
      if (collapseObj.id === index) {
        collapseObj.collapse = !collapseObj.collapse;
      } else {
        collapseObj.collapse = false;
      }
      newArray.push(collapseObj);
    }

    this.setState({ collapse: newArray });
  };

  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }

    this.setState({ buscar: this.search });
    this.setListaRecetasSurtidasPage(1);
  }

  // Inicia logica que controla la pestaña de regente (grid y detalle)
  search = [];

  handleSearch = (evt, obj) => {
    if (obj && obj.name === "especie") {
      evt ? (this.search[obj.name] = evt.id) : delete this.search[obj.name];
    } else {
      // Si el obj.target.name pertenece a un input type text aplicamos la funcion toUpperCase()
      [
        "folio_salida",
        "folio_receta",
        "establecimiento",
        "medico_veterinario_vende",
        "medico_veterinario_receta",
      ].includes(evt.target.name)
        ? (this.search[evt.target.name] = evt.target.value.toUpperCase())
        : (this.search[evt.target.name] = evt.target.value);
    }

    this.setState({ buscar: this.search });
  };

  // cleanSearch = () => {
  //   let search = this.state.buscar;

  //   for (const prop in search) {
  //     delete search[prop];
  //     document.getElementById(prop).value = "";
  //   }

  //   this.setState({ buscar: search });
  //   this.setListaRecetasSurtidasPage(1);
  // };

  //Funcion para cambiar de pagina en el grid de regente
  setListaRecetasSurtidasPage = (page) => {
    this.setState({ workingGrid: true });
    let search = this.state.buscar;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getSuppliedPrescription?page=" + page + src).then((s) => {
      this.setState({
        surtidas: s.data,
        paginas: s.last_page,
        registros: s.total,
        paginaActual: s.current_page,
        workingGrid: false,
      });
    });
  };

  handleListaRecetasElectronicasPage = (e) => {
    this.setListaRecetasSurtidasPage(e.target.value);
  };

  updatePrescriptionPrint = (id, nombrePDF) => {
    let fileName = nombrePDF.replace("/", "-");
    Api.loading(true);
    let receta = {
      id: id,
      nivelUsuario: this.state.nivelUsuario,
    };

    Api.fetch("app/updatePrescriptionPrint", receta, "PUT")
      .then((data) => {
        if (data) {
          this.setState({
            receta_electronica: data,
          });
        }
      })
      .then((res) => {
        Api.loading(false);
        printJS({
          printable: Api.url + `app/receta_electronica/?id=${id}`,
          type: "pdf",
          documentTitle: fileName,
          onPrintDialogClose: () => {
            if (this.state.nivelUsuario === "1") {
              window.location.href = "/recetas-electronicas/expedidas";
            }
          },
        });
      });
  };

  handleModalCloseBtn = (evt) => {
    evt.preventDefault();

    this.setState({
      workingModal: true,
      receta_electronica: "",
      modalState: false,
    });
  };

  openPrescriptModal = (evt) => {
    this.setState({ modalState: true });
    //buscamos la receta
    Api.fetch("app/getElectronicPrescription?id=" + evt.target.id)
      .then((data) => {
        if (data) {
          this.setState({
            receta_electronica: data,
          });
        }
      })
      .then((res) => {
        this.setState({ workingModal: false });
      });
  };

  handleCloseBtn = (evt) => {
    this.setState({ previa: false, receta_electronica: "" });
    if (this.state.nivelUsuario === "1") {
      window.location.reload();
    }
  };

  handleBajaRecetaBtn = (evt) => {
    Swal.fire({
      input: "textarea",
      title: "MOTIVO DE BAJA",
      inputPlaceholder: "Ingrese motivo de baja",
      showCancelButton: false,
      showDenyButton: true,
      denyButtonColor: "red",
      confirmButtonColor: "#4CD964",
      inputValidator: (value) => {
        return !value && "Debe ingresar el motivo de baja.";
      },
      denyButtonText: "Regresar",
      confirmButtonText: "Continuar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        let obj = {
          id: evt.target.id,
          observacion: result.value.toUpperCase(),
        };
        this.disablePrescription(obj);
      }
    });
  };

  disablePrescription = (obj) => {
    Api.loading(true);
    Api.fetch("app/disableElectronicPrescription", obj, "PUT").then((res) => {
      Api.loading(false);
      Swal.fire({
        icon: "success",
        title: "¡La receta ha sido dada de baja!",
        timer: 3000,
      }).then(() => {
        window.location.href = "/recetas-electronicas/expedidas";
      });
    });
  };

  printPrescriptionPDF = (receta) => {
    if (this.state.nivelUsuario === "1") {
      Swal.fire({
        icon: "warning",
        title: "Advertencia",
        text: "La receta electrónica sólo puede imprimirse una vez, ¿Desea continuar?",
        showDenyButton: true,
        denyButtonColor: "red",
        confirmButtonColor: "#4CD964",
        showCancelButton: false,
        confirmButtonText: `Abrir`,
        denyButtonText: `Regresar`,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.updatePrescriptionPrint(receta.id, receta.folio_receta);
        }
      });
    } else {
      this.updatePrescriptionPrint(receta.id, receta.folio_receta);
    }
  };

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/recetas-electronicas/surtidas">
              Recetas electrónicas
            </Link>
          </li>
          <li className="breadcrumb-item active">Surtidas</li>
        </ol>
        <h1 className="page-header">Recetas surtidas</h1>
        <div className="row">
          <div className="col-xl-12">
            <Nav tabs={true}>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "1",
                  })}
                  onClick={() => {
                    this.toggleTab("1");
                  }}
                >
                  <span className="d-sm-none">
                    RECETAS SURTIDAS
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros}
                    </span>
                  </span>
                  <span className="d-sm-block d-none">
                    RECETAS SURTIDAS
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros}
                    </span>
                  </span>
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <div className="table-responsive">
                  <fieldset>
                    <legend>Buscar</legend>

                    <div className="row">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="folio_salida">Folio salida:</label>
                          <div className="input-group">
                            <input
                              id="folio_salida"
                              name="folio_salida"
                              placeholder="Ingrese folio de salida"
                              onChange={this.handleSearch}
                              className="form-control"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="folio_receta">Folio receta:</label>
                          <div className="input-group">
                            <input
                              id="folio_receta"
                              name="folio_receta"
                              onChange={this.handleSearch}
                              placeholder="Ingrese folio de receta"
                              className="form-control"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="establecimiento">
                            Establecimiento de venta:
                          </label>
                          <div className="input-group">
                            <input
                              id="establecimiento"
                              name="establecimiento"
                              onChange={this.handleSearch}
                              placeholder="Ingrese establecimiento"
                              className="form-control"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className={"col-lg-3"}>
                        <div className="form-group">
                          <label htmlFor="medico_veterinario_vende">
                            Médico veterinario vende:
                          </label>
                          <div className="input-group">
                            <input
                              id="medico_veterinario_vende"
                              name="medico_veterinario_vende"
                              onChange={this.handleSearch}
                              placeholder="Ingrese médico vetirinario"
                              className="form-control"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>

                      <div className={"col-lg-3"}>
                        <div className="form-group">
                          <label htmlFor="medico_veterinario_receta">
                            Médico veterinario receta:
                          </label>
                          <div className="input-group">
                            <input
                              id="medico_veterinario_receta"
                              name="medico_veterinario_receta"
                              onChange={this.handleSearch}
                              placeholder="Ingrese médico vetirinario"
                              className="form-control"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-2">
                        <div className="form-group">
                          <label htmlFor="fecha_emision">
                            Expedición receta:
                          </label>
                          <div className="input-group">
                            <input
                              type="date"
                              name="fecha_emision"
                              onChange={this.handleSearch}
                              id="fecha_emision"
                              className="form-control"
                              placeholder="Fecha"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-2">
                        <div className="form-group">
                          <label htmlFor="fecha_salida">Fecha venta:</label>
                          <div className="input-group">
                            <input
                              type="date"
                              name="fecha_salida"
                              onChange={this.handleSearch}
                              id="fecha_salida"
                              className="form-control"
                              placeholder="Seleccione"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-2">
                        <div className="form-group">
                          <label htmlFor="search">&nbsp;</label>
                          <div className="input-group">
                            <button
                              type="button"
                              className="btn btn-orange w-100"
                              title="Buscar"
                              onClick={() =>
                                this.setListaRecetasSurtidasPage(1)
                              }
                            >
                              <i className="fa fa-search"></i> Buscar
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="search">&nbsp;</label>
                          <div className="input-group">
                            <button
                              type="button"
                              className="btn btn-blue w-100"
                              title="Limpiar"
                              onClick={this.cleanSearch}
                            >
                              <i className="fas fa-trash-alt"></i> Limpiar
                            </button>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </fieldset>
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-center">Folio salida</th>
                        <th className="text-center">Folio receta</th>
                        <th className="text-center">
                          Establecimiento de venta
                        </th>
                        <th className="text-center">
                          Médico veterinario vende
                        </th>
                        <th className="text-center">
                          Médico veterinario receta
                        </th>
                        <th className="text-center">Expedición receta</th>
                        <th className="text-center">Fecha venta</th>
                        {/* <th className="text-center" width="10%">
                          Acciones
                        </th> */}
                      </tr>
                    </thead>
                    <tbody className={this.state.workingGrid ? "hide" : ""}>
                      {this.state.surtidas && this.state.surtidas.length > 0 ? (
                        this.state.surtidas.map((s) => (
                          <tr key={s.id}>
                            <td className="text-center">
                              {s.folio_detalle_salida}
                            </td>
                            <td className="text-center">{s.folio_receta}</td>
                            <td className="text-center">
                              {s.razon_social}
                            </td>
                            <td className="text-center">
                              {s.medico_veterinario_vende}
                            </td>
                            <td className="text-center">
                              {s.medico_veterinario_receta}
                            </td>
                            <td className="text-center">
                              {s.fecha_expedicion}
                            </td>
                            <td className="text-center">{s.fecha_salida}</td>
                            {/* <td></td> */}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            <b>No se encontraron registros</b>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className={this.state.workingGrid ? "m-10" : "hide"}>
                    <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                      CARGANDO INFORMACIÓN
                    </div>
                  </div>
                  <hr />
                  <div className="d-flex align-items-center justify-content-center">
                    <ul className="pagination mb-0">
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setListaRecetasSurtidasPage(1);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-left"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (this.state.paginaActual - 1 > 0) {
                              this.setListaRecetasSurtidasPage(
                                this.state.paginaActual - 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-left"></i>
                        </button>
                      </li>
                      <li className="page-item d-flex align-items-center px-2">
                        <div>
                          Página
                          <strong>
                            {" "}
                            {this.state.paginaActual} de {this.state.paginas}
                          </strong>
                        </div>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (
                              this.state.paginas >=
                              this.state.paginaActual + 1
                            ) {
                              this.setListaRecetasSurtidasPage(
                                this.state.paginaActual + 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-right"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setListaRecetasSurtidasPage(
                              this.state.paginas
                            );
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-right"></i>
                        </button>
                      </li>
                    </ul>
                    <div className="ml-3 mr-1">Página:</div>
                    <div className="width-50 mx-2">
                      <input
                        className="form-control"
                        onChange={this.handleListaRecetasElectronicasPage}
                        type="number"
                        min="1"
                        max={this.state.paginas}
                        value={this.state.paginaActual}
                      />
                    </div>
                    <div></div>
                  </div>
                </div>
              </TabPane>
            </TabContent>
            {/* <div
              className={this.state.previa ? "previa" : "hide"}
              onContextMenu={(e) => e.preventDefault()}
            >
              <iframe
                title="Vista previa"
                className="rounded"
                src={this.state.previa_url}
                loading="eager"
              ></iframe>
              <center>
                <div className="btn-group">
                  <button onClick={this.handleCloseBtn} className="btn btn-danger">
                    Cerrar
                  </button>
                  <a
                    className="btn btn-primary"
                    href={this.state.previa_url + "&download=1"}
                    download="download"
                  >
                    Descargar
                  </a>
                </div>
              </center>
            </div> */}
            <Modal
              isOpen={this.state.modalState}
              tabIndex="-1"
              style={{
                maxWidth: "100%",
                width: "85%",
              }}
            >
              <ModalHeader
                width="100%"
                toggle={() => {
                  this.setState({
                    modalState: false,
                    workingModal: true,
                    receta_electronica: "",
                  });
                }}
                className="text-center"
              >
                {this.state.receta_electronica.folio_receta}
              </ModalHeader>
              <ModalBody>
                <form id="electronic-prescription">
                  <ShowForm
                    receta_electronica={this.state.receta_electronica}
                    workingModal={this.state.workingModal}
                  />
                </form>
              </ModalBody>
              <ModalFooter>
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <button
                        onClick={this.handleModalCloseBtn}
                        className="btn btn-danger float-right"
                      >
                        Regresar
                      </button>
                    </div>
                  </div>
                </div>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

export default Visits;
